import { MapPin, Phone, Clock, Navigation } from "lucide-react";
import { CONTACT } from "@/data/site";
import { Reveal } from "@/components/common/Reveal";
import { CtaPair } from "@/components/common/CtaButtons";

export const MapSection = () => (
  <section data-testid="map-section" className="bg-white">
    <div className="mx-auto max-w-[1440px] px-6 pb-24 md:px-12 md:pb-32 lg:px-20 lg:pb-40">
      <div className="overflow-hidden rounded-[2rem] border border-brand-line">
        <div className="grid lg:grid-cols-[1fr_1.2fr]">
          <Reveal className="bg-brand-accent p-8 text-white md:p-12">
            <h2 className="font-display text-3xl font-semibold md:text-4xl">Visit our clinic</h2>
            <p className="mt-3 text-white/60">
              Easy to find in Paharia with convenient parking and step-free access.
            </p>

            <ul className="mt-8 space-y-6">
              <li className="flex items-start gap-4">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" />
                <div>
                  <p className="text-sm font-semibold uppercase tracking-wider text-white/50">Address</p>
                  <p className="mt-1 text-white/90">{CONTACT.address}</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <Phone className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" />
                <div>
                  <p className="text-sm font-semibold uppercase tracking-wider text-white/50">Phone</p>
                  <a href={CONTACT.phoneTel} className="mt-1 block text-white/90 hover:text-brand-green">
                    {CONTACT.phoneDisplay}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <Clock className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" />
                <div>
                  <p className="text-sm font-semibold uppercase tracking-wider text-white/50">Timings</p>
                  {CONTACT.timings.map((t) => (
                    <p key={t.day} className="mt-1 text-white/90">{t.day}: {t.hours}</p>
                  ))}
                </div>
              </li>
            </ul>

            <div className="mt-8">
              <CtaPair />
            </div>
            <a
              href={CONTACT.gmbUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="get-directions-link"
              className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand-green hover:underline"
            >
              <Navigation className="h-4 w-4" /> Get directions
            </a>
          </Reveal>

          <div className="min-h-[360px]">
            <iframe
              title="Dr. Ankesh Seth clinic location"
              src={CONTACT.mapEmbed}
              className="h-full min-h-[360px] w-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);
